import { Injectable } from '@angular/core';
import {
  DwAction,
  DwActionHandler,
  DwActionResult,
  DwActionType,
  DwButtonType,
  DwMdFormActionState,
  DwMetaDataGridActionState
} from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AppPermissions } from '../../../meta-data/app-permissions.enum';
import { AppMetaDataItemNames, InvoiceEntity } from '../../../meta-data/app-meta-data.service';

@DwAction({
  keyName: 'openStripeInvoice',
  display: 'Open in Stripe',
  actionType: DwActionType.formAction,
  isGlobal: false,
  parentItemName: [AppMetaDataItemNames.Invoice],
  defaultSecurityConfig: {
    requireAuthentication: true,
    useEmulatedPermissions: false,
    permissionMeaning: AppPermissions.lMSAllSchoolsAdmin
  },
  defaultButtonConfig: {
    useParentDisplay: false,
    buttonText: 'Open in Stripe',
    buttonType: DwButtonType.standard,
    buttonClass: 'btn btn-secondary',
    iconClass: 'fa fa-external-link'
  }
})
@DwAction({
  keyName: 'openStripeInvoiceGrid',
  display: 'Open in Stripe',
  actionType: DwActionType.gridRowAction,
  isGlobal: false,
  parentItemName: [AppMetaDataItemNames.Invoice],
  defaultSecurityConfig: {
    requireAuthentication: true,
    useEmulatedPermissions: false,
    permissionMeaning: AppPermissions.lMSAllSchoolsAdmin
  },
  defaultMenuConfig: {
    useParentDisplay: false,
    menuDisplay: 'Open in Stripe'
  }
})
@Injectable()
export class OpenStripeInvoiceActionService implements DwActionHandler {
  handleAction(actionState: DwMdFormActionState | DwMetaDataGridActionState<InvoiceEntity>): Observable<DwActionResult> {
    const invoice = this.getInvoice(actionState);

    if (!invoice || !invoice.StripeInvoiceRef) {
      return of({
        success: false,
        message: 'This invoice has not been created in Stripe.'
      });
    }

    const isTestMode = environment.environment.stripePublicKey.indexOf('pk_test_') === 0;
    const modePath = isTestMode ? '/test' : '';
    const invoiceUrl = `https://dashboard.stripe.com${modePath}/invoices/${encodeURIComponent(invoice.StripeInvoiceRef)}`;

    window.open(invoiceUrl, '_blank', 'noopener,noreferrer');

    return of({ success: true });
  }

  private getInvoice(actionState: DwMdFormActionState | DwMetaDataGridActionState<InvoiceEntity>): InvoiceEntity {
    if ((actionState as DwMdFormActionState).formApi) {
      return (actionState as DwMdFormActionState).formApi.getFormData<InvoiceEntity>();
    }

    return (actionState as DwMetaDataGridActionState<InvoiceEntity>).data;
  }
}
